import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  Box1BelastbaarLoon, IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, filter, Subject, takeUntil} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {Event, NavigationEnd, Router} from "@angular/router";
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {SharedUiAlertModule} from '@snelstart/ui-alert';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-meer-banen-tegelijk',
  templateUrl: './meer-banen-tegelijk.component.html',
  styleUrls: ['./meer-banen-tegelijk.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule,
    SharedUiAlertModule
  ]
})
export class MeerBanenTegelijkComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  @Input() partner = new BehaviorSubject<boolean>(false);
  private isSaving = false;
  private destroy$ = new Subject<void>();
  public clientId!: string;
  public aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;
  public partnerBoolean = {} as boolean;
  public isDefAangifte = {} as boolean;
  private focusedElementId: string | null = null;
  public dubbelePositie = {} as FormGroup

  public optionsJaNee: SelectFormControlItem<boolean | undefined>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  constructor(public dataService: BokkzIbDataService,
              public dataAlgService: BokkzAlgDataService,
              private router: Router,
              private fb: FormBuilder) {
    this.dubbelePositie = this.fb.group<Box1BelastbaarLoon>({
      dubbelePositie: null as unknown as boolean
    })
  }

  dubbeleBanenOfUitkeringen(): boolean {
    let count = 0;
    const getLength = (path: any): number => path?.length || 0;

    if (this.partnerBoolean) {
      count += getLength(this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitTegenwoordigeDienstbetrekking);
      if (count >= 2) return true;
      count += getLength(this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking);
      if (count >= 2) return true;
    } else {
      count += getLength(this.incomeTaxEntity.aangifte?.box1?.belastbaarLoon?.loonUitTegenwoordigeDienstbetrekking);
      if (count >= 2) return true;
      count += getLength(this.incomeTaxEntity.aangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking);
      if (count >= 2) return true;
    }
    return count >= 2;
  }

  public ngOnInit(): void {
    this.dataService.isDefAangifte.pipe(takeUntil(this.destroy$)).subscribe((isDefAangifte) => {
      this.isDefAangifte = isDefAangifte;
    });
    this.dataService.incomeTaxEntity.pipe(takeUntil(this.destroy$)).subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        this.updateForm();
        this.partner.pipe(takeUntil(this.destroy$)).subscribe((partner) => {
          this.partnerBoolean = partner
          this.dubbelePositie.reset()
          this.updateForm();
        });
      }
    });
    this.dataAlgService.client.pipe(takeUntil(this.destroy$)).subscribe((client) => {
      this.clientId = client.sstRelationId!;
    })
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleUrlChange(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.destroy$) {
      this.destroy$.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntityMetLoonheffing(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.dubbelePositie.dirty;
  }

  private updateForm(): void {
    let dubbel = false;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
    if (this.partnerBoolean) {
      dubbel = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.dubbelePositie || false;
      this.dubbelePositie.patchValue({dubbelePositie: dubbel});
    } else {
      dubbel = this.incomeTaxEntity.aangifte?.box1?.belastbaarLoon?.dubbelePositie || false;
      this.dubbelePositie.patchValue({dubbelePositie: dubbel});
    }
    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
    if (!this.partnerBoolean) {
      this.incomeTaxEntity.aangifte = {
        ...this.incomeTaxEntity.aangifte,
        box1: {
          ...this.incomeTaxEntity.aangifte?.box1,
          belastbaarLoon: {
            ...this.incomeTaxEntity.aangifte?.box1?.belastbaarLoon,
            dubbelePositie : this.dubbelePositie.value.dubbelePositie,
          }
        }
      } as Aangifte;
      setTimeout(() => {
        this.dataService.postIncomeTaxEntityMetLoonheffing(this.clientId, false, this.incomeTaxEntity);
      }, 500)
    } else {
      this.incomeTaxEntity.aangifte = {
        ...this.incomeTaxEntity.aangifte,
        partnerAangifte: {
          ...this.incomeTaxEntity.aangifte?.partnerAangifte,
          box1: {
            ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1,
            belastbaarLoon: {
              ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.belastbaarLoon,
              dubbelePositie : this.dubbelePositie.value.dubbelePositie,
            }
          },
        },
      } as Aangifte;
      setTimeout(() => {
        this.dataService.postIncomeTaxEntityMetLoonheffing(this.clientId, false, this.incomeTaxEntity);
      }, 500)
    }
    this.dubbelePositie.markAsDirty();
  }
}

